export default __webpack_public_path__ + "static/media/campaign2.33308caf.png";